/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BotExamReviewQuestionViewModel } from "../types/BotExamReviewQuestionViewModel.ts";
import { botExamReviewQuestionOptionViewModelSchema } from "./botExamReviewQuestionOptionViewModelSchema.ts";

export const botExamReviewQuestionViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da questão gerada pelo bot.")),
  label: z
    .string()
    .describe("Enunciado da questão gerada pelo bot. Opcional.")
    .nullish(),
  explanation: z
    .string()
    .describe("Explicação da resposta correta gerada pelo bot. Opcional.")
    .nullish(),
  transcriptExcerpt: z
    .string()
    .describe(
      "Trecho da transcrição de aula utilizado como base para a geração da questão. Opcional.",
    )
    .nullish(),
  shouldTranslate: z.optional(
    z
      .boolean()
      .describe("Define se a questão deve ser traduzida para outros idiomas."),
  ),
  isReviewed: z.optional(
    z.boolean().describe("Indica se a questão já foi revisada pelo revisor."),
  ),
  type: z.optional(
    z
      .number()
      .int()
      .describe(
        "Tipo numérico da questão gerada pelo bot (identificador interno de formato de questão).",
      ),
  ),
  options: z
    .array(z.lazy(() => botExamReviewQuestionOptionViewModelSchema))
    .describe("Lista de alternativas da questão gerada pelo bot.")
    .nullish(),
}) as unknown as ToZod<BotExamReviewQuestionViewModel>;
